<template>
  <div
    class="flex flex-col justify-between w-full pb-4 overflow-hidden border-gray-300 md:flex-row"
    :class="[level == 1 ? 'bg-blank border-t border-b' : '-m-3']"
  >
    <ul
      class="flex flex-row justify-start w-full h-full overflow-x-scroll overflow-y-hidden whitespace-no-wrap lg:overflow-visible disable-scrollbars"
    >
      <li
        class="mx-4 my-3 text-center"
        v-for="(route, i) in routeLinks"
        :key="i"
      >
        <router-link
          active-class="submenu-active"
          class="px-4 py-3 text-sm font-semibold text-gray-700 hover:text-gray-900 hover:no-underline"
          :to="route.to"
          :disabled="route.disabled"
        >
          {{ route.title }}
        </router-link>
      </li>
    </ul>
    <slot></slot>
    <div class="mt-2 text-right md:mt-0">
      <portal-target name="submenu" v-if="level == 2"></portal-target>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routes: {
      type: Array,
      required: true,
    },
    level: {
      type: Number,
      requried: false,
      default: 1,
    },
  },
  computed: {
    routeLinks() {
      return this.routes.filter(r => !r.disabled)
    },
  },
}
</script>

<style>
.submenu-active {
  @apply border-b-4 border-lagon-500 text-gray-900 !important;
}
</style>
